export class MstContracts{
    SupplierID!: string;
    SupplierName!: string;
    ContractId!: string;
    ContractDescription!: string;
    ID!: number;
    IsActive!: boolean;
    CreatedBy!: string;
    CreatedDate!: Date;
    UpdatedBy!: string;
    UpdatedDate!: Date;
}